// TelcoTrack — Sklady route guard.
// Saved profile `sections.materials.view` (chip Sklady — číst). Role alone does not open the page.

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { canViewMaterialsSection } from '@core/shared-bridge';

export const materialsGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const user = authService.getCurrentUser();
  if (canViewMaterialsSection(authService.getSessionRoles(), user?.permissionProfile)) {
    return true;
  }
  return router.createUrlTree(['/403']);
};
